import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { CPL3Settings, GlobalClientPortalSettingsModel, ICPLClientPortalSettingsClient } from "./api/cplapi/CPLAPI";

export interface IClientPortalCPLSettingsService {
  getBooleanSetting(settingType: CPL3Settings): Promise<boolean>;
  getGlobalClientPortalSettings(): Promise<GlobalClientPortalSettingsModel>;
  getIntSetting(settingType: CPL3Settings): Promise<number | undefined>;
}

@injectable()
export class ClientPortalCPLSettingsService implements IClientPortalCPLSettingsService {
  @inject(SERVICE_TYPES.CPLClientPortalSettingsClient) cplSettingsClient!: ICPLClientPortalSettingsClient;

  async getBooleanSetting(settingType: CPL3Settings): Promise<boolean> {
    return await this.cplSettingsClient.getBooleanSetting(settingType);
  }

  getGlobalClientPortalSettings(): Promise<GlobalClientPortalSettingsModel> {
    return this.cplSettingsClient.getGlobalClientPortalSettings();
  }

  async getIntSetting(settingType: CPL3Settings): Promise<number | undefined> {
    return this.cplSettingsClient.getIntSetting(settingType);
  }
}
